import { render, staticRenderFns } from "./CarrosselAberturaConta.vue?vue&type=template&id=39b9d3e2&scoped=true"
import script from "./CarrosselAberturaConta.vue?vue&type=script&lang=js"
export * from "./CarrosselAberturaConta.vue?vue&type=script&lang=js"
import style0 from "./CarrosselAberturaConta.vue?vue&type=style&index=0&id=39b9d3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9d3e2",
  null
  
)

export default component.exports